import { useLayoutEffect } from 'react'
import { useDarkModeContext } from '../providers/darkModeProvider/DarkModeProvider'

/**
 * Registers the current component as a dark-mode-eligible page.
 * Sets `isDarkModeAllowedOnPage` to `true` on mount and reverts to `false` on unmount,
 * so pages that don't call this hook always render in the 'day' theme even when the user
 * has dark mode enabled globally.
 *
 * Uses a layout effect so the theme switches before the browser paints; a regular effect
 * would paint the page in the 'day' theme first and then flash to 'night'.
 *
 * @returns {void}
 */
export default function useAllowDarkMode() {
  const { setIsDarkModeAllowedOnPage } = useDarkModeContext()

  useLayoutEffect(() => {
    setIsDarkModeAllowedOnPage(true)
    return () => setIsDarkModeAllowedOnPage(false)
  }, [setIsDarkModeAllowedOnPage])
}
